export const Locations = [
  { id: 0, title: "Select", selected: false, key: "select" },
  // { id: 1, title: "NSW", selected: false, key: "nsw" },
  { id: 2, title: "VIC", selected: false, key: "vic" },
  //{ id: 3, title: "QLD", selected: false, key: "qld" },
  { id: 4, title: "WA", selected: false, key: "wa" },
  //{ id: 5, title: "SA", selected: false, key: "sa" },
  //{ id: 6, title: "NT", selected: false, key: "nt" },
];
